import { Fa6 } from "react-icons/fa6";

interface LinkButtonProps {
  link: string;
  text: string;
  Icon?: typeof Fa6;
}

const LinkButton: React.FC<LinkButtonProps> = ({ link, text, Icon }) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className="
      dark:bg-neutral-gray-700
      dark:text-white 
      dark:hover:bg-neutral-gray-900 
      bg-white
      text-neutral-gray-500
      hover:bg-neutral-gray-100
      w-fit 
      text-base 
      font-bold 
      px-4 
      py-1 
      rounded-lg 
      whitespace-nowrap 
      transition-all 
      h-14
      flex
      items-center
      gap-3
      fill-slate-50
      min-w-[235px]
      "
    >
      {Icon && (
        <Icon className="dark:fill-primary-blue-300 fill-primary-blue-400" />
      )}{" "}
      {text}
    </a>
  );
};

export default LinkButton;